import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CommitStatusBadge } from '../CommitStatusBadge';
import IssueCounter from '../IssueCounter';
import QuickFixesIcon from '../QuickFixesIcon';
import CommitStatus from './CommitStatus';
export default class CommitStatusDone extends CommitStatus {
    renderCounter(issuesCount, issuesDiff) {
        return _jsx(IssueCounter, { issuesCount: issuesCount, issuesDiff: issuesDiff });
    }
    renderQuickFixes(fixFilesCount) {
        if (fixFilesCount) {
            return _jsx(QuickFixesIcon, {});
        }
    }
    renderStatusBadge(commitOptions, errorCount, warningCount, isCommitDone, isCommitTimedOut, isCommitMeetingThreshold, loading) {
        return _jsx(CommitStatusBadge, { commitOptions: commitOptions, errorCount: errorCount, warningCount: warningCount, isCommitDone: isCommitDone, isCommitTimedOut: isCommitTimedOut, isCommitMeetingThreshold: isCommitMeetingThreshold, loading: loading });
    }
}
